import { name, os, version } from 'platform';

export const getBrowserName = () => name?.toLowerCase();

export const getBrowserVersion = () => version;

export const getOSName = () => os?.family;
